import type { NotificationListResponse } from "../types/notification";
import { apiFetch } from "./client";

const BASE = "/api/v1/doctor/notifications";

export async function listNotifications(
  page = 1,
  pageSize = 20,
): Promise<NotificationListResponse> {
  const params = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });
  return apiFetch<NotificationListResponse>(`${BASE}?${params}`);
}

/**
 * Fetch unread notification count.
 *
 * Pass `{ background: true }` ONLY for caller-driven polling (e.g. the
 * 30s interval inside `useUnreadCount`). User-triggered refreshes (route
 * change, explicit reload) MUST omit the flag — otherwise the request
 * tells the backend to skip the sliding-window touch and the user gets
 * a premature 401 on the next idle check (HH-200 Unit 28).
 */
export async function getUnreadCount(
  opts: { background?: boolean } = {},
): Promise<number> {
  const headers = opts.background ? { "X-Activity": "background" } : undefined;
  const data = await apiFetch<{ unread_count: number }>(
    `${BASE}/unread-count`,
    headers ? { headers } : {},
  );
  return data.unread_count;
}

export async function markAsRead(notificationId: string): Promise<void> {
  await apiFetch<void>(`${BASE}/${notificationId}/read`, { method: "PATCH" });
}
